import { useCallback } from 'react';
import { HydratedCallRecord } from '@weave/schema-gen-ts/dist/schemas/phone-exp/phone-records/v1/call_record.pb';
import { CallQualityV1 } from '@frontend/api-call-quality';
import { CallQualityScreen as CallQuality } from '@frontend/phone-panels';
import { useCallInsightPanelShallowStore } from '../../hooks/use-call-insight-panel-store';
import { ScreenBaseProps, ScreenType } from '../../types';
import { ScreenLayout } from '../screen-layout';

export type CallQualityScreenProps = ScreenBaseProps;

export const CallQualityScreen = ({ panelStyles, source, onClose, setScreen }: CallQualityScreenProps) => {
  const { contexts, closeContext } = useCallInsightPanelShallowStore('contexts', 'closeContext');

  const panelContext = contexts[source];
  const callRecord = panelContext?.selectedCall as HydratedCallRecord; //TODO:To be fixed after call intel [Call] type migration to schema-gen

  const { data, isLoading } = CallQualityV1.Queries.useGetCallQualityMetricsQuery({
    request: {
      callStartTime: callRecord?.answeredAt || '',
      channelId: callRecord?.channelId || '',
    },
    options: {
      enabled: !!(callRecord?.answeredAt && callRecord?.channelId),
    },
  });

  const handleClose = useCallback(() => {
    closeContext();
    !!onClose && onClose();
  }, [closeContext, onClose]);

  return (
    <ScreenLayout
      panelStyles={panelStyles}
      onClose={handleClose}
      header={
        <CallQuality.Header call={callRecord} onBack={() => setScreen({ screenType: ScreenType.CALL_INSIGHTS })} />
      }
      content={
        <CallQuality.Content
          call={callRecord}
          data={data}
          isLoading={isLoading}
          onTimelineClick={(_data) => {
            setScreen({
              screenType: ScreenType.CALL_QUALITY_DRILLDOWN,
              data: {
                ..._data,
                startTime: data?.callAnsweredTime || '',
                channelId: callRecord?.channelId || '',
                locationId: callRecord?.locationId || '',
              },
            });
          }}
        />
      }
    />
  );
};
